import z from 'zod'
import {HTTPError} from 'ky'
import {ERROR_DEFAULT} from 'features/common/core/errors'
import api from 'features/common/transport'
const STATUS_BAD_REQUEST = 400
const STATUS_TOO_EARLY = 425

const sendCodeResponseSchema = z.object({
    code_alive_seconds: z.number(),
    email: z.string(),
    next_send_allowed_seconds: z.number(),
    sent_at: z.string().datetime(),
})
const sendCode = async (email: string) => {
    try {
        const res = await api.post('verification/email/sendCode', {
            body: JSON.stringify({email}),
        })

        const parseRes = sendCodeResponseSchema.safeParse(await res.json())
        if (parseRes.success) {
            return {
                resendTimeout: parseRes.data.next_send_allowed_seconds,
            }
        }

        throw new Error(ERROR_DEFAULT)
    } catch (err) {
        if (err instanceof HTTPError) {
            if (err.response.status === STATUS_BAD_REQUEST) {
                throw new Error('ERROR_CODE_RESEND_WRONG_EMAIL')
            }
            if (err.response.status === STATUS_TOO_EARLY) {
                throw new Error('ERROR_CODE_RESEND_TOO_EARLY')
            }
        }

        throw new Error(ERROR_DEFAULT)
    }
}
export default sendCode
